import { useRouter } from 'next/router';
import { FC } from 'react';
import {
  generateUrl,
  USER_CLICK_LOGO,
} from 'components/FollowSearchResultsNavigation/logics/generateUrl';
import styles from './index.module.scss';

/**
 * Logo コンポーネントのプロパティ
 */
interface Props {
  /** ログイン判定 */
  loginStatus: boolean;
}

/**
 * Logo コンポーネント
 * @param {Props} props - Logo コンポーネントのプロパティ
 * @returns {JSX.Element} レンダリングされたコンポーネント
 */
export const Logo: FC<Props> = ({ loginStatus }) => {
  const router = useRouter();

  return (
    <a
      className={styles.followSearchResultsNavigation__logo}
      href={generateUrl({
        baseUrl: '/',
        userClickList: USER_CLICK_LOGO,
        pathname: router.pathname,
        loginStatus,
      })}
    >
      <img
        src="https://src.doda.jp/cmn_web/img/logo_doda/logo_bg_119x40.png"
        alt="doda"
      />
    </a>
  );
};
